import { Permission } from '~core/models/roles.models';
import { ROUTES } from './routes.constants';

export const SIDEBAR_LINKS: Array<{
  id: string;
  label: string;
  url: string;
  icon: string;
  tooltip?: string;
  hasBadge?: boolean;
  exactActive?: boolean;
  sectionTitle?: string;
  permissions?: Permission[];
  preserveQueryParams?: boolean;
  enabled?: boolean;
}> = [
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    icon: 'discover',
    url: '/',
    exactActive: true,
    sectionTitle: 'Général',
    tooltip:
      'Suivez vos principaux indicateurs de facturation (factures, reçus, taxes, stickers) sur la période sélectionnée'
  },
  {
    id: 'sticker',
    label: 'Gestion de stickers',
    icon: 'wallet',
    url: '/stickers',
    hasBadge: true,
    sectionTitle: 'Stickers',
    permissions: [Permission.READ_STICKER],
    tooltip:
      'Consultez votre solde, l’historique et rechargez votre solde de stickers'
  },
  {
    id: 'invoices',
    label: 'Mes factures',
    icon: 'file-validation',
    url: ROUTES.invoices,
    hasBadge: true,
    sectionTitle: 'Ventes & achats',
    permissions: [Permission.READ_INVOICE],
    // preserveQueryParams: true
    tooltip:
      'Consultez et gérez vos factures émises et réceptionnées (statuts, téléchargements, historique)'
  },
  {
    id: 'receipts',
    label: 'Mes reçus',
    icon: 'receipt',
    url: ROUTES.receipts,
    hasBadge: true,
    permissions: [Permission.READ_RECEIPT],
    tooltip:
      'Consultez et gérez vos reçus émis et reçus (statuts, téléchargements, historique)'
  },
  // TODO: display after design is ready
  // {
  //   id: 'favourite',
  //   label: "Note d'avoirs 3R",
  //   icon: 'money-receive',
  //   url: '/asset-management',
  //   hasBadge: true,
  //   enabled: false,
  //   tooltip: 'Émettez et consultez vos notes d’avoirs'
  // },
  {
    id: 'customerSupplier',
    label: 'Partenaires',
    icon: 'user-group',
    url: '/customer-supplier',
    hasBadge: true,
    permissions: [Permission.READ_CUSTOMER_SUPPLIER],
    tooltip:
      'Gérez vos clients et fournisseurs pour faciliter l’émission de vos factures'
  },
  {
    id: 'product',
    label: 'Gestion des articles',
    icon: 'store',
    url: '/articles',
    hasBadge: true,
    sectionTitle: 'Catalogue',
    permissions: [Permission.READ_PRODUCT],
    tooltip:
      'Créez et gérez votre catalogue de produits et services pour la facturation'
  },
  {
    id: 'unitMeasure',
    label: 'Unités de mesure',
    icon: 'tape-measure',
    url: '/unite-mesures',
    hasBadge: true,
    permissions: [Permission.READ_UNIT_MEASURE],
    tooltip:
      'Paramétrez les unités de mesure utilisées pour votre facturation (pièce, kg, litre…)'
  },
  {
    id: 'organizationManagement',
    label: 'Mon organisation',
    icon: 'building-02',
    url: '/organizations',
    hasBadge: true,
    exactActive: false,
    sectionTitle: 'Paramètres, Sécurité & Compte',
    permissions: [Permission.READ_ORGANIZATION],
    tooltip:
      'Consultez et mettez à jour les informations administratives et fiscales de votre entreprise'
  },
  {
    id: 'etablishments',
    label: 'Mes établissements',
    icon: 'building',
    url: ROUTES.establishments,
    hasBadge: true,
    permissions: [Permission.READ_ESTABLISHMENT],
    tooltip:
      'Gérez vos établissements et points de vente rattachés à votre compte FNE'
  },
  {
    id: 'ternes',
    label: 'Mes TERNEs',
    icon: 'ai-phone',
    url: '/ternes',
    hasBadge: true,
    permissions: [Permission.READ_TERNES],
    tooltip: 'Gerer les TERNES'
  },
  {
    id: 'users',
    label: 'Gestion des utilisateurs',
    icon: 'account-setting',
    url: ROUTES.users,
    hasBadge: true,
    permissions: [Permission.READ_USER],
    tooltip:
      'Créez des utilisateurs, attribuez des rôles et gérez les habilitations'
  },
  {
    id: 'apiIntegration',
    label: 'Intégration API',
    icon: 'ai-programming',
    url: ROUTES.apiIntegration,
    hasBadge: true,
    permissions: [Permission.READ_API_KEY],
    tooltip: 'Configurez vos clés et la connexion API de votre organisation'
  },
  {
    id: 'auditLog',
    label: 'Audit Logs',
    icon: 'bug',
    url: ROUTES.auditLogs,
    hasBadge: true,
    permissions: [Permission.READ_AUDIT_LOG],
    tooltip:
      'Consultez le journal d’audit retraçant les actions réalisées sur votre compte'
  }
];
